module.exports = __webpack_public_path__ + "static/img/71 (2).a23a1ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/71 (2).jpg
// module id = 13Yu
// module chunks = 0